import React from 'react';

import type { CreateLumappsChatAgentConfig } from '@lumapps/ai-ag-ui/api';
import { useDispatch } from '@lumapps/redux/react';

import { AgentChatContext } from '../context/AgentChatContext';
import { actions as agentHubActions } from '../ducks/slice';

/**
 * Retrieves a callback to open the global agent chat
 */
export const useOpenAgentChat = () => {
    const { getInstance } = React.useContext(AgentChatContext);

    const dispatch = useDispatch();

    return React.useCallback(
        (
            /**
             * Configuration to init the agent with
             * If left undefined, will simply open the chat with the current agent
             */
            agentConfiguration?: CreateLumappsChatAgentConfig,
        ) => {
            if (agentConfiguration) {
                const { agentInstance } = getInstance();
                // If the agent already has messages, ask for confirmation before changing
                if (agentInstance && agentInstance.messages.length > 0) {
                    dispatch(agentHubActions.requestAgentChange(agentConfiguration));
                } else {
                    dispatch(agentHubActions.setSelectedAgent(agentConfiguration));
                    dispatch(agentHubActions.setDrawerOpen(true));
                }
            } else {
                dispatch(agentHubActions.setDrawerOpen(true));
            }
        },
        [dispatch, getInstance],
    );
};
